import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/sharp-solid-svg-icons';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { CircularProgress, IconButton } from '@mui/material';
import React, { forwardRef } from 'react';
import { FEATURE_FLAG_KEYS } from '../../../../config/growthbook';
import styles from './DocumentRagIcon.module.css';

export interface DocumentRagIconProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  disabled?: boolean;
}

export const DocumentRagIcon = forwardRef<
  HTMLButtonElement,
  DocumentRagIconProps
>(({ loading = false, disabled = false, onClick }, ref) => {
  const isDocRagEnabled = useFeatureIsOn(FEATURE_FLAG_KEYS.SUBMISSIONS_DOC_RAG);

  // Don't render if feature flag is off
  if (!isDocRagEnabled) {
    return null;
  }

  return (
    <IconButton
      ref={ref}
      onClick={onClick}
      disabled={disabled || loading}
      className={styles.iconButton}
      aria-label="Extract document data"
    >
      {loading ? (
        <CircularProgress size={16} className={styles.loadingSpinner} />
      ) : (
        <span className={styles.iconContainer}>
          <FontAwesomeIcon icon={faSearch} className={styles.magnifyingGlass} />
          <FontAwesomeIcon icon={faSparkles} className={styles.sparkles} />
        </span>
      )}
    </IconButton>
  );
});
DocumentRagIcon.displayName = 'DocumentRagIcon';
